import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { useLang } from '../context/LanguageContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PayPalButton({ lookupKey, className = '' }) {
  const { t, lang } = useLang();
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const [clientId, setClientId] = useState('');
  const [sdkReady, setSdkReady] = useState(false);

  useEffect(() => {
    axios.get(`${API}/payments/config`)
      .then(({ data }) => {
        if (data.paypal_enabled && data.paypal_client_id) setClientId(data.paypal_client_id);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!clientId) return;
    const existing = document.getElementById('paypal-sdk-script');
    if (existing) {
      if (window.paypal) setSdkReady(true);
      else existing.addEventListener('load', () => setSdkReady(true));
      return;
    }
    const s = document.createElement('script');
    s.id = 'paypal-sdk-script';
    s.src = `https://www.paypal.com/sdk/js?client-id=${clientId}&currency=USD&intent=capture&disable-funding=credit`;
    s.onload = () => setSdkReady(true);
    document.body.appendChild(s);
  }, [clientId]);

  useEffect(() => {
    if (!sdkReady || !containerRef.current || !window.paypal) return;
    containerRef.current.innerHTML = '';
    window.paypal.Buttons({
      style: { layout: 'vertical', color: 'gold', shape: 'rect', label: 'paypal', height: 48 },
      createOrder: async () => {
        const { data } = await axios.post(`${API}/paypal/order`, { lookup_key: lookupKey, language: lang });
        return data.order_id;
      },
      onApprove: async (data) => {
        try {
          const res = await axios.post(`${API}/paypal/order/${data.orderID}/capture`);
          if (res.data.payment_status === 'paid') {
            navigate(`/payment/success?paypal_order=${data.orderID}`);
          } else {
            toast.error(t('form.error'));
          }
        } catch (e) {
          toast.error(t('form.error'));
        }
      },
      onError: () => toast.error(t('form.error')),
    }).render(containerRef.current);
  }, [sdkReady, lookupKey, lang, navigate, t]);

  if (!clientId) return null;

  return (
    <div className={className}>
      <p className="text-xs text-slate-500 mb-3 text-center">{t('common.orPaypal')}</p>
      <div ref={containerRef} data-testid="paypal-buttons" className="max-w-sm mx-auto" />
    </div>
  );
}
